const $header = document.querySelector('.n-header')

if ($header) {
    header($header)
}

function header($wrapper) {

    const $mobileButton = document.querySelector('.n-header__mobile-button')
    const $mobileMenu = document.querySelector('.n-header__mobile')
    const $mobileMenuItems = document.querySelectorAll('.n-header__mobile-menu-item')
    const $mobileMenuCloseButton = document.querySelector('.n-header__mobile-closed')
    const $languageMenu = document.querySelector('.n-header__language')
    const $currentLanguageButton = document.querySelector('.n-header__language-current')

    const headerScrollClass = 'n-header--scroll';
    const headerMobileOpenClass = 'n-header__mobile--open';
    const languageOpenClass = 'n-header__language--open';

    if (window.scrollY > 0) {
        $wrapper.classList.add(headerScrollClass)
    } else {
        $wrapper.classList.remove(headerScrollClass)
    }

    window.addEventListener('scroll', () => {
        if (window.scrollY > 0) {
            $wrapper.classList.add(headerScrollClass)
        } else {
            $wrapper.classList.remove(headerScrollClass)
        }
    })

    $mobileButton.addEventListener('click', () => {
        $mobileMenu.classList.add(headerMobileOpenClass)
    })

    $mobileMenuItems.forEach(($mobileMenuItem) => {
        $mobileMenuItem.addEventListener('click', () => {
            $mobileMenu.classList.remove(headerMobileOpenClass)
        })
    })

    $mobileMenuCloseButton.addEventListener('click', () => {
        $mobileMenu.classList.remove(headerMobileOpenClass)
    })

    $currentLanguageButton.addEventListener('click', () => {
        $languageMenu.classList.toggle(languageOpenClass)
    })
}
